// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"ela-z","displaySixCardTiles":"fla-z"};